export const QUIZ_EMAIL_CAPTURE = {
  event: "quiz_form_event",
  formEvent: {
    formName: "email_capture",
    formLocation: "main",
    formId: "quiz-email-form-id",
    formMarketingName: "quiz_email_capture",
    formType: "single-step",
  },
} as const;
